import React, { useEffect, useState } from "react";
import { Button, Select, Upload, Tooltip, Form, Divider, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getStates } from "../features/statecity/statecitySlice";
import { getBrands, getJobtrades } from "../features/brand/brandSlice";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { getUsers } from "../features/cutomers/customerSlice";
import { base_url } from "../utils/baseUrl";
import Papa from "papaparse";
import FileSaver from "file-saver";

// const { Option } = Select;

const Addbulkvt = () => {
  const statelistState = useSelector((state) => state.statecity.statelist);
  const vclistState = useSelector((state) => state.customer.customers);
  // const classlistState = useSelector((state) => state.brand.brands);
  // const jobtradelistState = useSelector((state) => state.brand.jobtrades);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [selectedState, setSelectedState] = useState("");
  const [vcData, setVcData] = useState([]);
  const [selectedVC, setSelectedVC] = useState("");
  // const [selectedClass, setSelectedClass] = useState("");
  // const [selectedJobRole, setSelectedJobRole] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getStates());
    dispatch(getJobtrades());
    dispatch(getBrands());
    dispatch(getUsers());
  }, [dispatch]);

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setVcData(vcfilterData);
    setSelectedState(value);
  };

  const handleVCChange = (value) => {
    setSelectedVC(value);
  };

  // const handleClassChange = (value) => {
  //   setSelectedClass(value);
  // };

  // const handleJobRoleChange = (value) => {
  //   setSelectedJobRole(value);
  // };

  const downloadSampleCsv = () => {
    FileSaver.saveAs(
      `${process.env.PUBLIC_URL}/sample_download/Sample_VT.csv`,
      "Sample_VT.csv"
    );
  };

  const handleFileUpload = (info) => {
    const file = info.file.originFileObj || info.file;

    if (!file) {
      toast.dismiss();
      toast.error("Failed to load file. Please try again.", {
        autoClose: 10000,
      });
      return;
    }

    if (
      file.type !== "text/csv" &&
      file.type !== "application/vnd.ms-excel" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      toast.error("Please upload a CSV or XLSX file.", { autoClose: 5000 });
      return;
    }

    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const headers = results.meta.fields;
        const requiredColumns = [
          "name",
          "unique_id",
          "email",
          "phone_no",
          "qualification",
          "experience",
          "skill_area",
          "state",
          "district",
          "cluster_name",
          "school_name",
          "address",
          "role",
          "school_id",
          "Job Role",
        ];
        const missingColumns = requiredColumns.filter(
          (column) => !headers.includes(column)
        );

        if (missingColumns.length > 0) {
          toast.dismiss();
          toast.error(
            `Missing required columns: ${missingColumns.join(", ")}`,
            { autoClose: 10000 }
          );
          return;
        }

        const columns = headers.map((header) => ({
          title: header,
          dataIndex: header,
          key: header,
        }));

        setColumns(columns);
        setCsvData(results.data);
        toast.dismiss();
        toast.success("CSV file loaded successfully.", { autoClose: 5000 });
      },
      error: (error) => {
        toast.dismiss();
        toast.error("Failed to parse file.", { autoClose: 5000 });
      },
    });
  };

  const handleSubmit = () => {
    setLoading(true);
    if (csvData.length === 0) {
      toast.dismiss();
      toast.error("Please upload the CSV File Before Submitting.", {
        autoClose: 5000,
      });
      return;
    }

    const userinfo = localStorage.getItem("user");
    if (!userinfo) {
      toast.dismiss();
      toast.error("User information not found. Please log in again.", {
        autoClose: 5000,
      });
      return;
    }

    const userData = JSON.parse(userinfo);
    const token = userData.token;

    if (!token) {
      toast.dismiss();
      toast.error("Token not found in local storage.", { autoClose: 5000 });
      return;
    }

    const data = {
      state_name: selectedState,
      vc_name: selectedVC,
      csvData: csvData, // Send parsed CSV data
    };

    fetch(`${base_url}user/upload-vtuser`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Print Data Message ------", data);
        if (data.status === "fail") {
          toast.error(data.message, { autoClose: 5000 });
          setLoading(false);
          form.resetFields();
          setCsvData([]);
          setColumns([]);
        } else {
          toast.dismiss();
          toast.success(data.message, { autoClose: 5000 });
          setLoading(false);
          form.resetFields();
          setCsvData([]);
          setColumns([]);
        }
      })
      .catch((error) => {
        toast.dismiss();
        form.resetFields();
        setLoading(false);
        toast.error("File upload failed.", { autoClose: 10000 });
      });
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Button
        type="link"
        onClick={() => navigate(-1)}
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "1rem",
          color: "#4a90e2",
        }}
      >
        <BiArrowBack /> Go Back
      </Button>

      <Divider />

      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="primary"
            className="exportcsv"
            onClick={downloadSampleCsv}
          >
            <DownloadOutlined /> Sample VT (Vocational Trainer)
          </Button>
        </div>
        <h4 style={{ marginBottom: "20px", color: "#333333" }}>
          Upload VT (Vocational Trainer)
        </h4>
        <Form form={form} layout="inline">
          <Form.Item
            name="state_name"
            rules={[{ required: true, message: "Please Select State!" }]}
          >
            <Select
              placeholder="Select State"
              onChange={handleStateChange}
              style={{ width: 150, marginRight: 5 }}
            >
              {statelistState.map((state) => (
                <Select.Option key={state.code} value={state.code}>
                  {state.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="vc_name"
            rules={[{ required: true, message: "Please Select VC!" }]}
          >
            <Select
              placeholder="Select VC"
              onChange={handleVCChange}
              style={{ width: 150, marginRight: 5 }}
            >
              {vcData
                .filter((item) => item.role === "vc")
                .map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item name="file">
            <Tooltip title="Only .csv or .xlsx files are accepted">
              <Upload
                accept=".csv,.xlsx"
                beforeUpload={() => false}
                onChange={handleFileUpload}
                showUploadList={true}
              >
                <Button icon={<UploadOutlined />}>UPLOAD</Button>
              </Upload>
            </Tooltip>
          </Form.Item>
        </Form>

        <Button
          type="primary"
          style={{ width: 100, marginTop: 20 }}
          onClick={handleSubmit}
          loading={loading}
        >
          Submit
        </Button>

        {csvData.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            <h5>Uploaded CSV Sheet Preview</h5>
            <Table
              columns={columns}
              dataSource={csvData}
              rowKey={(record, index) => index}
            />
          </div>
        )}

        <Divider />
      </div>
    </div>
  );
};

export default Addbulkvt;
